import React from "react";
import "./input.scss";

function Input({ type, ...rest }) {
  return <input className="input" type={type} {...rest} />;
}

export default Input;
